import { WhatsappTemplate } from '../services/whatsappService';

export const TEMPLATE_TYPE_OPTIONS: { value: WhatsappTemplate['type']; label: string; group: string }[] = [
  { value: 'reminder_7_days', label: 'Reminder H-7', group: 'reminder' },
  { value: 'reminder_3_days', label: 'Reminder H-3', group: 'reminder' },
  { value: 'reminder_1_day', label: 'Reminder H-1', group: 'reminder' },
  { value: 'reminder_due_today', label: 'Reminder Hari H', group: 'reminder' },
  { value: 'bill_reminder', label: 'Pengingat Tagihan (Manual)', group: 'tagihan' },
  { value: 'overdue_notice', label: 'Pemberitahuan Tunggakan', group: 'tagihan' },
  { value: 'payment_created', label: 'Pembayaran Dibuat', group: 'pembayaran' },
  { value: 'payment_confirmed', label: 'Konfirmasi Pembayaran', group: 'pembayaran' },
  { value: 'custom', label: 'Custom', group: 'lainnya' },
];

export const TEMPLATE_TYPE_FILTER_OPTIONS = [
  { value: '', label: 'Semua tipe' },
  ...TEMPLATE_TYPE_OPTIONS.map((o) => ({ value: o.value, label: o.label })),
];

const BILL_VARS = [
  { key: '{customerName}', desc: 'Nama pelanggan' },
  { key: '{customerId}', desc: 'Kode pelanggan' },
  { key: '{packageName}', desc: 'Nama paket' },
  { key: '{amount}', desc: 'Jumlah tagihan (Rp)' },
  { key: '{period}', desc: 'Periode tagihan' },
  { key: '{dueDate}', desc: 'Jatuh tempo' },
  { key: '{link}', desc: 'Link bayar otomatis (sesuai gateway aktif)' },
  { key: '{linkTripay}', desc: 'Link Tripay — VA/Transfer' },
  { key: '{linkPaybos}', desc: 'Link PayBOS — QRIS' },
  { key: '{invoiceLink}', desc: 'Link unduh invoice PDF tagihan' },
];

const PAYMENT_CREATED_VARS = [
  ...BILL_VARS.filter((v) => !v.key.includes('link') || v.key === '{link}'),
  { key: '{paymentMethodName}', desc: 'Metode pembayaran' },
  { key: '{reference}', desc: 'Referensi pembayaran' },
  { key: '{expiredTime}', desc: 'Batas waktu bayar' },
  { key: '{payCode}', desc: 'Kode VA (jika ada)' },
  { key: '{linkTripay}', desc: 'Link Tripay' },
  { key: '{linkPaybos}', desc: 'Link PayBOS QRIS' },
  { key: '{invoiceLink}', desc: 'Link unduh invoice PDF tagihan' },
];

const PAYMENT_CONFIRMED_VARS = [
  { key: '{customerName}', desc: 'Nama pelanggan' },
  { key: '{customerId}', desc: 'Kode pelanggan' },
  { key: '{packageName}', desc: 'Nama paket' },
  { key: '{amount}', desc: 'Jumlah dibayar' },
  { key: '{period}', desc: 'Periode tagihan' },
  { key: '{paymentDate}', desc: 'Tanggal pembayaran' },
  { key: '{invoiceLink}', desc: 'Link unduh invoice PDF tagihan' },
];

const CUSTOM_VARS = [
  ...BILL_VARS,
  { key: '{paymentDate}', desc: 'Tanggal pembayaran' },
  { key: '{paymentMethodName}', desc: 'Metode pembayaran' },
  { key: '{reference}', desc: 'Referensi' },
  { key: '{expiredTime}', desc: 'Kedaluwarsa' },
  { key: '{payCode}', desc: 'Kode pembayaran' },
];

export function getTemplateTypeLabel(type: string): string {
  return TEMPLATE_TYPE_OPTIONS.find((o) => o.value === type)?.label || type;
}

export function getTemplateVariables(type: string) {
  if (['bill_reminder', 'overdue_notice', 'reminder_7_days', 'reminder_3_days', 'reminder_1_day', 'reminder_due_today'].includes(type)) {
    return BILL_VARS;
  }
  if (type === 'payment_created') return PAYMENT_CREATED_VARS;
  if (type === 'payment_confirmed') return PAYMENT_CONFIRMED_VARS;
  return CUSTOM_VARS;
}

export type TemplateFormState = {
  id: number;
  name: string;
  type: WhatsappTemplate['type'];
  template: string;
  status?: string;
  spop_id?: string;
  isActive: boolean;
};

export const EMPTY_TEMPLATE: TemplateFormState = {
  id: 0,
  name: '',
  type: 'bill_reminder',
  template: '',
  isActive: true,
};
